import { DEFAULT_GRID_SLOTS_COMPONENTS } from '@material-ui/data-grid';
import { createSlice } from '@reduxjs/toolkit';
import * as Api from '../Api';

export const homeSlice = createSlice({
  name: 'home',
  initialState: {
    customerResponse: [],
    createCustomerResponse: [],
    accountSearchResponse: [],
    createCustomerResponsev2: [],
    accountSearchResponseLength: null,
  },
  reducers: {
    setCustomerResponse: (state, action) => {
      state.customerResponse = action.payload;
    },
    setCreateCustomerResponse: (state, action) => {
      state.createCustomerResponse = action.payload;
    },
    setAccountsSearched: (state, action) => {
      state.accountSearchResponse = action.payload;
    },
    setCreateCustomerResponsev2: (state, action) => {
      state.createCustomerResponsev2 = action.payload;
    },
    setAccountSearchResponseLength: (state, action) => {
      state.accountSearchResponseLength = action.payload;
    },
  },
});

export function getCustomerDetails() {
  return async (dispatch) => {
    var response = await Api.getRequest('/customer/', 'GET');
    dispatch(setCustomerResponse(response));
  };
}

export function createCustomer(details) {
  return async (dispatch) => {
    var response = await Api.postRequest('/customer/', 'POST', details);
    dispatch(setCreateCustomerResponse(response));
  };
}

export function createCustomerv2(details) {
  return async (dispatch) => {
    var response = await Api.postRequest('/customer/persist/', 'POST', details);
    dispatch(setCreateCustomerResponsev2(response));
  };
}

export function getAccountDetails(accountName, accountNumber) {
  return async (dispatch) => {
    var response = await Api.getRequest(
      '/customer/search/?partialAccountName=' + accountName + '&accountNum=' + accountNumber,
      'GET',
    );
    dispatch(setAccountsSearched(response));
    console.log(response);
    dispatch(setAccountSearchResponseLength(response.length));
  };
}

export function resetCustomerStates() {
  return async (dispatch) => {
    dispatch(setCreateCustomerResponse([]));
    dispatch(setAccountsSearched([]));
    dispatch(setCreateCustomerResponsev2([]));
  };
}

export const {
  setCustomerResponse,
  setCreateCustomerResponse,
  setAccountsSearched,
  setCreateCustomerResponsev2,
  setAccountSearchResponseLength,
} = homeSlice.actions;
export const setCustomerSelector = (state) => state.home.customerResponse;
export const createCustomerSelector = (state) => state.home.createCustomerResponse;
export const createCustomerSelectorv2 = (state) => state.home.createCustomerResponsev2;
export const getAccountDetailsSelector = (state) => state.home.accountSearchResponse;
export const setAccountSearchResponseLengthSelector = (state) =>
  state.home.accountSearchResponseLength;
export default homeSlice.reducer;
